(() => {
  const init = () => {
    const sticky = document.querySelector('[data-pointer-sticky-buy]');
    const mainProduct = document.querySelector('.product__info-container');
    if (!sticky || !mainProduct) return;

    const mainButton = mainProduct.querySelector('[id^="ProductSubmitButton-"]');
    const mainForm = mainProduct.querySelector('form[data-type="add-to-cart-form"]');
    const variantPicker = mainProduct.querySelector('variant-selects');
    const sizeFieldset = Array.from(mainProduct.querySelectorAll('fieldset.product-form__input')).find((fieldset) =>
      fieldset.querySelector('legend')?.textContent.trim().toLowerCase().startsWith('size')
    );
    const stickyButton = sticky.querySelector('[data-pointer-sticky-button]');
    const status = sticky.querySelector('[data-pointer-sticky-status]');
    const priceElement = sticky.querySelector('[data-pointer-sticky-price]');
    const mrpElement = sticky.querySelector('[data-pointer-sticky-mrp]');
    const discountElement = sticky.querySelector('[data-pointer-sticky-discount]');
    const variantData = document.querySelector('[data-pointer-sticky-variants]');
    let variants = [];
    let sizeConfirmed = !sizeFieldset;

    try {
      variants = JSON.parse(variantData?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const updateStickyPrice = () => {
      const variantId = String(mainForm?.querySelector('[name="id"]')?.value || '');
      const variant = variants.find((item) => String(item.id) === variantId);
      if (!variant || !priceElement || !mrpElement || !discountElement) return;

      const hasDiscount = Number(variant.compareAtPrice) > Number(variant.price);
      priceElement.textContent = hasDiscount ? variant.priceFormatted : 'MRP ' + variant.priceFormatted;
      mrpElement.hidden = !hasDiscount;
      discountElement.hidden = !hasDiscount;

      if (hasDiscount) {
        mrpElement.textContent = 'MRP ' + variant.compareAtPriceFormatted;
        const discountPercent = Math.round(
          ((Number(variant.compareAtPrice) - Number(variant.price)) / Number(variant.compareAtPrice)) * 100
        );
        discountElement.textContent = discountPercent + '% OFF';
      }
    };

    const setConfirmed = () => {
      sizeConfirmed = true;
      stickyButton.textContent = 'Add to cart';
    };

    sizeFieldset?.querySelectorAll('input, label').forEach((element) => element.addEventListener('click', setConfirmed));

    const requestSize = (event) => {
      if (sizeConfirmed) return;
      event?.preventDefault();
      event?.stopImmediatePropagation();
      sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizeFieldset.querySelector('input:not(.disabled)')?.focus({ preventScroll: true });
      status.textContent = 'Please choose your waist size before adding to cart.';
    };

    mainForm?.addEventListener('submit', requestSize, true);

    stickyButton.addEventListener('click', () => {
      if (!sizeConfirmed) {
        requestSize();
        return;
      }
      mainButton?.click();
    });

    if (mainButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }, { threshold: .15 });
      observer.observe(mainButton);
    }

    updateStickyPrice();

    variantPicker?.addEventListener('change', () => {
      if (sizeConfirmed) stickyButton.textContent = 'Add to cart';
      window.setTimeout(updateStickyPrice, 0);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
